export default __webpack_public_path__ + "static/media/35k.1aceb321.yaml";